import { render, staticRenderFns } from "./generateStatementAccount.vue?vue&type=template&id=e5acf35a&scoped=true"
import script from "./generateStatementAccount.vue?vue&type=script&lang=js"
export * from "./generateStatementAccount.vue?vue&type=script&lang=js"
import style0 from "./generateStatementAccount.vue?vue&type=style&index=0&id=e5acf35a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5acf35a",
  null
  
)

export default component.exports